// import Image from 'next/image'
import { Image } from 'antd';
import Styles from './index.module.scss';

interface IProps {
  coverUrl: string;
  name: string;
  selected?: boolean;
  onClick: Function;
}

const VideoCard = ({ coverUrl, name, selected = false, onClick }: IProps) => {
  const cardOnClick = () => {
    if (!selected) {
      onClick();
    }
  };

  return (
    <div className={Styles.videoCard} onClick={cardOnClick}>
      <Image
        width={148}
        height={148}
        src={coverUrl}
        alt={name}
        preview={false}
        crossOrigin="anonymous"
      />
      <div className={Styles.videoCardMask}></div>
      <span className={Styles.videoName}>{name}</span>
      {selected && <div className={Styles.selectedBox}></div>}
    </div>
  );
};

export default VideoCard;
